
export const registrationCharges = [
    {
        delegateType: "Delegate",
        earlyBird: 4750,
        standard: 6000,
        earlyOneDay: 1750,
        standardOneDay: 2400,
        registrationTypes: [
            "Delegate"
        ]
    },
    {
        delegateType: "Discounted (for Students and Persons with Disability)",
        earlyBird: 2400,
        standard: 3000,
        earlyOneDay: 1200,
        standardOneDay: 1500,
        registrationTypes : [ 
            "Student", 
            "Person with Disability"
        ]
    },
    {
        delegateType: "Accompanying Person #",
        earlyBird: 1200,
        standard: 1200,
        earlyOneDay: 600,
        standardOneDay: 600,
        registrationTypes: [
            "Accompanying Person"
        ]
    },
]

export const notes = [
    {
        note: "Last date of early bird registration is 25th September 2026",
        subNotes:[]
    },
    {
        note: "All charges are inclusive of GST (18%)",
        subNotes:[]
    },
    {
        note: "Regular registration includes",
        subNotes: [
            "Participation in all conference keynotes, workshops and thematic sessions",
            "Welcome Kit",
            "Lunch and tea during conference",
            "1 Banquet Dinner"
        ]
    },
    {
        note: "Limited fellowship for complimentary registration available for students and Person with disabilities.",
        subNotes: []
    },
    {
        note: "(*) One day registrations do not include Banquet dinner. However, dinner coupon can be purchased on the spot.",
        subNotes: []
    },
    {
        note: "(#) Accompanying persons registration only include lunch and tea during conference.",
        subNotes: []
    }
]


